import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule } from '@angular/material/dialog';
import { CommonUtilService } from '../../services/common-util/common-util.service';
import { Permissions } from '../../enum/permission'
import { AppConfigService } from '../../services/config/app-config.service';
import { ContactDialogComponent } from '../../print-monitor/contact-dialog/contact-dialog.component';
import { Router } from '@angular/router';
import { LoaderComponent } from '../../common-component/loader/loader.component';
@Component({
  selector: 'app-search-status-popup',
  standalone: true,
  imports: [MatDialogModule, LoaderComponent],
  templateUrl: './search-status-popup.component.html',
  styleUrl: './search-status-popup.component.scss',
})
export class SearchStatusPopupComponent implements OnInit {
  public isMobileDevice: boolean = false;
  addedByShow: boolean = false
  permissionArray: any = []
  showContact: boolean = false
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    private isMobile: CommonUtilService,
    private dialog: MatDialog,
    private _appConfig: AppConfigService,
    private router: Router) { }
  ngOnInit(): void {
    console.log(this.data);
    
    this.isMobileDevice = this.isMobile.isMobileDevice();
    this.fetchPermission()
    this.fetchRecordStatus()
  }
  fetchRecordStatus() {
    let statusDetails: any = JSON.parse(atob(localStorage.getItem('recstatus')!))
    statusDetails = new Map(statusDetails.map((item: { status_code: any; status_desc: any; }) => [item?.status_code, item.status_desc]))
    if (statusDetails.has(this.data.data.recordStatus))
      this.data.data.status = statusDetails.get(this.data.data.recordStatus)
  }
  copy(value: number | string) {
  navigator.clipboard.writeText(value.toString());
}
  // fetchPermission() {
  //   this.permissionArray = this._appConfig.fetchPermissionv3ByViewName();
  //   let permissionArray = [];
  //   const countryPerm = this.permissionArray['INDIA'];
  //   if (this.data?.data?.permanentState != '') {
  //     permissionArray = countryPerm.allStatesPerm;
  //     const statePerm = countryPerm.statePerms[this.data?.data?.permanentState];
  //     if (this.data.data?.permanentDistrict.value !== '' && statePerm?.districtPerms[this.data.data?.permanentDistrict]) {
  //       permissionArray = [...permissionArray, ...statePerm?.allDistrictsPerm, ...statePerm.districtPerms[this.data.data?.permanentDistrict]];
  //     }
  //   }

  //   console.log(permissionArray, 'permission array')
  //   if (permissionArray?.includes(Permissions.CanAccessContactNo)) {
  //     this.showContact = true;
  //   }
  // }
  fetchPermission() {
    let finalPerm: any = [];
    this.permissionArray = this._appConfig.fetchPermissionv3ByViewName();
    const countryPerm = this.permissionArray['INDIA'];
    if (this.data?.data?.permanentState != '' && this.data?.data?.permanentState) {
      finalPerm = countryPerm?.allStatesPerm;
      const statePerm = countryPerm?.statePerms[this.data?.data?.permanentState];
      console.log(this.data.data?.permanentDistrict !== '', statePerm?.districtPerms[this.data.data?.permanentDistrict])

      if (this.data.data?.permanentDistrict !== '') {
        statePerm?.allDistrictsPerm ? finalPerm = [...finalPerm, ...statePerm?.allDistrictsPerm] : finalPerm = [...finalPerm];
        if (statePerm?.districtPerms[this.data.data?.permanentDistrict])
          finalPerm = [...finalPerm, ...statePerm?.districtPerms[this.data.data?.permanentDistrict]]
      }
    }
    console.log(finalPerm, 'permission array')
    this.showContact = finalPerm?.includes(Permissions.CanAccessContactNo)

  }

  onContactClick(item: any) {
    if (this.showContact) {
      this.dialog.open(ContactDialogComponent, {
        data: {
          slno: item.memberKey,
          type: true
        }
      })
    }
  }
}
